// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containloader {
  background: transparent;
  text-align: center;
  /*line-height: 100vh;*/
}

.zgroup {
  position: relative;
  display: inline-block;
  line-height: 16px;
}

.bigSqr {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  -webkit-transform-origin: bottom left;
  -ms-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-animation: bigSqrShrink 1s linear infinite;
  animation: bigSqrShrink 1s linear infinite;
}

.square {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #0ca59d;
}

.first {
  left: 0px;
  top: 20px;
}

.second {
  left: 20px;
  top: 20px;
  -webkit-animation: drop2 1s linear infinite;
  animation: drop2 1s linear infinite;
}

.third {
  left: 0px;
  top: 0px;
  -webkit-animation: drop3 1s linear infinite;
  animation: drop3 1s linear infinite;
}

.fourth {
  left: 20px;
  top: 0px;
  -webkit-animation: drop4 1s linear infinite;
  animation: drop4 1s linear infinite;
}

@-webkit-keyframes bigSqrShrink {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  90% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
}

@keyframes bigSqrShrink {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  90% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  100% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
}
@-webkit-keyframes drop2 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  25% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
@keyframes drop2 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  25% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
@-webkit-keyframes drop3 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  50% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
@keyframes drop3 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  50% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
@-webkit-keyframes drop4 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  75% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
@keyframes drop4 {
  0% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
  75% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  100% {
    -webkit-transform: translate(0);
    transform: translate(0);
  }
}
`, "",{"version":3,"sources":["webpack://./css/spinner.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF","sourcesContent":[".containloader {\n  background: transparent;\n  text-align: center;\n  /*line-height: 100vh;*/\n}\n\n.zgroup {\n  position: relative;\n  display: inline-block;\n  line-height: 16px;\n}\n\n.bigSqr {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  -webkit-transform-origin: bottom left;\n  -ms-transform-origin: bottom left;\n  transform-origin: bottom left;\n  -webkit-animation: bigSqrShrink 1s linear infinite;\n  animation: bigSqrShrink 1s linear infinite;\n}\n\n.square {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background: #0ca59d;\n}\n\n.first {\n  left: 0px;\n  top: 20px;\n}\n\n.second {\n  left: 20px;\n  top: 20px;\n  -webkit-animation: drop2 1s linear infinite;\n  animation: drop2 1s linear infinite;\n}\n\n.third {\n  left: 0px;\n  top: 0px;\n  -webkit-animation: drop3 1s linear infinite;\n  animation: drop3 1s linear infinite;\n}\n\n.fourth {\n  left: 20px;\n  top: 0px;\n  -webkit-animation: drop4 1s linear infinite;\n  animation: drop4 1s linear infinite;\n}\n\n@-webkit-keyframes bigSqrShrink {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  90% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n}\n\n@keyframes bigSqrShrink {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  90% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  100% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n}\n@-webkit-keyframes drop2 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  25% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n@keyframes drop2 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  25% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n@-webkit-keyframes drop3 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  50% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n@keyframes drop3 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  50% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n@-webkit-keyframes drop4 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  75% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n@keyframes drop4 {\n  0% {\n    -webkit-transform: translateY(-50px);\n    transform: translateY(-50px);\n  }\n  75% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n  100% {\n    -webkit-transform: translate(0);\n    transform: translate(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
